import { render } from "./DynamicResources.vue?vue&type=template&id=68124f8b&scoped=true"
import script from "./DynamicResources.vue?vue&type=script&lang=js"
export * from "./DynamicResources.vue?vue&type=script&lang=js"

import "./DynamicResources.vue?vue&type=style&index=0&id=68124f8b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68124f8b"

export default script